import React from "react";
import CountUp from "react-countup";
import "./Home.css";
import whychoose from "../../assets/images/whychoose.png";
import circle from "../../assets/images/circle.png";
import { Link } from "react-router-dom"; //Link

function parseCounterValue(valStr, defaultNum, defaultLabel) {
  if (!valStr) return { number: defaultNum, label: defaultLabel };
  const str = String(valStr).trim();
  const match = str.match(/^(\d+(?:\.\d+)?)\s*(.*)$/);
  if (match) {
    return { number: parseFloat(match[1]), label: match[2] };
  }
  return { number: defaultNum, label: str || defaultLabel };
}

function Whychoose({ homeSettings = {} }) {
  const subtitle =
    homeSettings.home_choose_title &&
    homeSettings.home_choose_title.trim() !== ""
      ? homeSettings.home_choose_title
      : "Why Choose CaresAtHome?";
  const title =
    homeSettings.home_choose_subtitle &&
    homeSettings.home_choose_subtitle.trim() !== ""
      ? homeSettings.home_choose_subtitle
      : "Trusted by Families for Quality Healthcare & Compassionate Support.";
  const description =
    homeSettings.home_choose_description &&
    homeSettings.home_choose_description.trim() !== ""
      ? homeSettings.home_choose_description
      : "We provide professional healthcare services designed to ensure comfort, safety, and personalized medical support for patients at home and hospital. Our experienced healthcare team is committed to delivering quality care with trust and compassion.";
  const link =
    homeSettings.home_choose_link && homeSettings.home_choose_link.trim() !== ""
      ? homeSettings.home_choose_link
      : "/about";
  const image =
    homeSettings.home_choose_image &&
    homeSettings.home_choose_image.trim() !== ""
      ? homeSettings.home_choose_image
      : whychoose;

  const stat1 = parseCounterValue(homeSettings.home_choose_value1, 200, "+");
  const text1 =
    homeSettings.home_choose_text1 || "Verified Healthcare Professionals";

  const stat2 = parseCounterValue(homeSettings.home_choose_value2, 2, "k");
  const text2 =
    homeSettings.home_choose_text2 || "Patients Served Successfully";

  return (
    // <div className="whychoose_section">
    //   <div className="container-fluid">
    //     <div className="row">
    //       <div className="col-lg-5 col-md-5 col-sm-12 col-12">
    //         <div className="whychoose_img">
    //           <img src={image} alt={subtitle} className="img-fluid main_img" />
    //           <div className="choose_wheel">
    //             <img src={circle} alt="" className="img-fluid " />
    //           </div>
    //         </div>
    //       </div>
    //       <div className="col-lg-7 col-md-7 col-sm-12 col-12">
    //         <div className="whychoose_content">
    //           <p className="subtitle">{subtitle}</p>
    //           <h3 className="title">{title}</h3>
    //           <div className="row counter_row">
    //             <div className="col-lg-5 col-md-5 col-sm-12 col-12">
    //               <div className="whychoose_counter">
    //                 <div className="stat-item">
    //                   <h3>
    //                     <CountUp
    //                       start={0}
    //                       end={stat1.number}
    //                       duration={7}
    //                       delay={0.5}
    //                       enableScrollSpy
    //                       scrollSpyOnce
    //                     />
    //                     <label>{stat1.label}</label>
    //                   </h3>

    //                   <p>{text1}</p>
    //                 </div>

    //                 <div className="stat-item">
    //                   <h3>
    //                     <CountUp
    //                       start={0}
    //                       end={stat2.number}
    //                       duration={7}
    //                       delay={0.5}
    //                       enableScrollSpy
    //                       scrollSpyOnce
    //                     />
    //                     <label>{stat2.label}</label>
    //                   </h3>

    //                   <p>{text2}</p>
    //                 </div>
    //               </div>
    //             </div>
    //             <div className="col-lg-7 col-md-7 col-sm-12 col-12">
    //               <div className="whychoose_para">
    //                 <p>{description}</p>
    //                 <button className="btn-book">
    //                   {" "}
    //                   <Link to={link}>Explore More</Link>
    //                 </button>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="whychoose_section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-5 col-sm-12 col-12">
            <div className="whychoose_img">
              <img src={image} alt={subtitle} className="img-fluid main_img" />
              <div className="choose_wheel">
                <img src={circle} alt="" className="img-fluid " />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-7 col-sm-12 col-12">
            <div className="whychoose_content">
              <p className="subtitle">About Us</p>
              <h3 className="title">
                Reliable Products, Conveniently Available on Rent.
              </h3>
              <div className="row counter_row">
                <div className="col-lg-5 col-md-5 col-sm-12 col-12">
                  <div className="whychoose_counter">
                    <div className="stat-item">
                      <h3>
                        <CountUp
                          start={0}
                          end={500}
                          duration={7}
                          delay={0.5}
                          enableScrollSpy
                          scrollSpyOnce
                        />
                        <label>+</label>
                      </h3>

                      <p>Products Available</p>
                    </div>

                    <div className="stat-item">
                      <h3>
                        <CountUp
                          start={0}
                          end={2000}
                          duration={7}
                          delay={0.5}
                          enableScrollSpy
                          scrollSpyOnce
                        />
                        <label>+</label>
                      </h3>

                      <p>Successful Rentals</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-12 col-12">
                  <div className="whychoose_para">
                    <p>
                      We provide a wide range of quality products on rent,
                      offering convenience, flexibility, and affordability for
                      your everyday needs. With reliable products, flexible
                      rental options, and timely support, we make renting simple
                      and hassle-free.
                    </p>
                    <button className="btn-book">
                      {" "}
                      <Link to="/about">Read More</Link>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Whychoose;
